module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Italic.7a4a7c5826462af432aa8fdc9546a2b8.woff";